export default "__VITE_ASSET__97b9ae29__"